import React from 'react'
import styles from '../../styles.module.css'


const fmt = (v) => (v === null || v === undefined || v === '') ? '—' : v

const num = (v) => {
  const n = Number(v)
  return Number.isFinite(n) ? n : 0
}

const sumFields = (row, fields) => fields.reduce((acc, f) => acc + num(row[f]), 0)

const NOO_CLASSES = ['1', '2', '3', '4']
const OOO_CLASSES = ['5', '6', '7', '8', '9']
const SOO_CLASSES = ['10', '11']

const ALL_GROUPS = [
  { title: 'Начальное общее образование', classes: NOO_CLASSES },
  { title: 'Основное общее образование',  classes: OOO_CLASSES },
  { title: 'Среднее общее образование',   classes: SOO_CLASSES },
]

const RIGHT_COLS = [
  { key: 'military', label: 'Детей военнослужащих',  field: 'militaryChildren' },
  { key: 'gpVS',     label: 'Детей ГП ВС',           field: 'civPersonnelMoD' },
  { key: 'ovz',      label: 'Детей с ОВЗ',           field: 'ovzChildren' },
  { key: 'quota',    label: 'Штатная наполняемость', field: 'totalStaffQuota' },
]

const TOTAL_COLS =
  2 +
  ALL_GROUPS.reduce((acc, g) => acc + (g.classes.length + 1) * 2, 0) +
  2 +
  RIGHT_COLS.length


const SummarySchoolsTable = ({ row }) => {
  return (
    <table className={styles.mainTable}>
      <thead>
        <tr className={styles.titleRow}>
          <th className={styles.titleLeft} colSpan={TOTAL_COLS - 1}>Сведения об обучающихся</th>
          <th className={styles.titleRight}>Форма №4/СВУ</th>
        </tr>
        <tr className={`${styles.titleRow} ${styles.secondTitleRow}`}>
          <th className={styles.titleLeft} colSpan={TOTAL_COLS - 1}>{row.organizationName}</th>
          <th className={styles.titleRight}>Таблица №1</th>
        </tr>

        <tr>
          <th colSpan={2}>Группы продлённого дня</th>
          {ALL_GROUPS.map(g => (
            <th key={g.title} colSpan={(g.classes.length + 1) * 2}>{g.title}</th>
          ))}
          <th colSpan={2}>Итого</th>
          {RIGHT_COLS.map(c => (
            <th key={c.key} rowSpan={3} className={styles.vertical}>{c.label}</th>
          ))}
        </tr>

        <tr>
          <th rowSpan={2} className={styles.vertical}>гр.</th>
          <th rowSpan={2} className={styles.vertical}>чел.</th>
          {ALL_GROUPS.map(g => (
            <React.Fragment key={g.title}>
              {g.classes.map(c => <th key={c} colSpan={2}>{c} класс</th>)}
              <th colSpan={2}>Всего</th>
            </React.Fragment>
          ))}
          <th rowSpan={2} className={styles.vertical}>кл.</th>
          <th rowSpan={2} className={styles.vertical}>чел.</th>
        </tr>

        <tr>
          {ALL_GROUPS.map(g => (
            <React.Fragment key={g.title}>
              {g.classes.map(c => (
                <React.Fragment key={c}>
                  <th className={styles.vertical}>кл.</th>
                  <th className={styles.vertical}>чел.</th>
                </React.Fragment>
              ))}
              <th className={styles.vertical}>кл.</th>
              <th className={styles.vertical}>чел.</th>
            </React.Fragment>
          ))}
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>{fmt(row.gpdCount)}</td>
          <td>{fmt(row.gpdStudentsCount)}</td>
          {ALL_GROUPS.map(g => {
            const classesFields = g.classes.map(c => `classes${c}`)
            const listFields = g.classes.map(c => `list${c}`)
            return (
              <React.Fragment key={g.title}>
                {g.classes.map(c => (
                  <React.Fragment key={c}>
                    <td>{fmt(row[`classes${c}`])}</td>
                    <td>{fmt(row[`list${c}`])}</td>
                  </React.Fragment>
                ))}
                <td>{sumFields(row, classesFields)}</td>
                <td>{sumFields(row, listFields)}</td>
              </React.Fragment>
            )
          })}
          <td>{fmt(row.classesTotal)}</td>
          <td>{fmt(row.listTotal)}</td>
          {RIGHT_COLS.map(c => <td key={c.key}>{fmt(row[c.field])}</td>)}
        </tr>
      </tbody>
    </table>
  )
}

export default SummarySchoolsTable
